

















import Vue from 'vue';

export default Vue.extend({
  props: {
    group: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      groupName: null,
    };
  },
  methods: {
    confirmInput() {
      if (!this.groupName || this.groupName === '') {
        this.$Message.warning('请输入组名');
      } else {
        this.$emit('confirm', this.groupName);
      }
    },
  },
  mounted() {
    if (this.group) {
      this.groupName = this.group.name;
    }
  },
});
